import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import {
  iOrganization,
  iOrganizationHelpDeskTicketType,
} from "@sdk/user-management/user-management.models";
import { UserTracker } from "user-tracker";

export class TicketTypesServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.ticketTypes.config = config;
  }

  ticketTypes = Object.assign(
    { config: SDKConfig },
    {
      addTicketType: async (data: iOrganizationHelpDeskTicketType) => {
        UserTracker.track("TICKET_TYPES - Create", {});
        const results: AxiosResponse<iOrganization> = await axios.post(
          this.config.basePath + `/organizations/ticket-types`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      editTicketType: async (
        id: string,
        data: iOrganizationHelpDeskTicketType,
      ) => {
        UserTracker.track("TICKET_TYPES - Edit", {});
        const results: AxiosResponse<iOrganization> = await axios.patch(
          this.config.basePath + `/organizations/ticket-types/${id}`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      deleteTicketType: async (id: string) => {
        UserTracker.track("TICKET_TYPES - Delete", {});
        const results: AxiosResponse<iOrganization> = await axios.delete(
          this.config.basePath + `/organizations/ticket-types/${id}`,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
    },
  );
}
